var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlyphArrowright(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 43@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Media",
    transform: "translate(-1193.000000, -1897.000000)",
    stroke: "#010101",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 1614.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(1084.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(117.500000, 12.500000) rotate(-90.000000) translate(-117.500000, -12.500000) translate(111.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 16,
    id: "Path-10"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    points: "0 9.5 6.5 17 13 9.5"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyphArrowright);
export default __webpack_public_path__ + "static/media/glyph-arrow.right.f889863e6e24f6a0f33ea2ec88395379.svg";
export { ForwardRef as ReactComponent };